export class Briefcase {
	public title: string;
	public id: string;
	public comments: string;
	public createdByEmail: string;
	public createdAt: Date;
	public customDesignation: string;
	public hasBatesStampPages: boolean;
	public totalDocuments: number;
	public size: string;
	public status: number;
	public isSelected: boolean;
	public isShared: boolean;
	public sharedId: string;
}
